import type { OrderConfirmationBannerAnalytics } from '@library/api-customer-engagement-experience'
import { queueTrackingEvent } from '@library/tracking-integration'

export const trackAction = (analytics?: OrderConfirmationBannerAnalytics) => {
  if (!analytics) return

  queueTrackingEvent<OrderConfirmationBannerAnalytics>(analytics)
}
